import React from 'react';
import styled, { css } from 'styled-components';
import tw from 'tailwind.macro';

import LogoCV from '../images/logo-cv.png';
import LoadingLoader from './LoadingLoader';

export default ({ show }) => (
  <Container show={show}>
    <Logo src={LogoCV} />
    <Message>Cargando información...</Message>
    <Loader />
  </Container>
);

const Container = styled.div`
  background-color: rgba(255, 255, 255, 0.95);

  ${(props) => !props.show && css`
    animation: fadeOut .3s ease-in forwards;
  `}

  ${tw`
    h-screen w-screen fixed flex justify-center items-center
    flex-col z-50
  `}
`;

const Message = styled.p`
  color: #a0aec0;
  ${tw`
    text-sm -mb-3
  `}
`;

const Logo = styled.img`
  ${tw`
    w-32
  `}
`;

const Loader = styled(LoadingLoader)`
  ${tw`
  `}
`;
